import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PageHeadingState {
  heading: string;
}

const initialState: PageHeadingState = {
  heading: "",
};

const pageHeadingSlice = createSlice({
  name: "pageHeading",
  initialState,
  reducers: {
    setPageHeading: (state, action: PayloadAction<string>) => {
      state.heading = action.payload;
    },
    clearPageHeading: (state) => {
      state.heading = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase("clear", () => initialState);
  },
});

export const { setPageHeading, clearPageHeading } = pageHeadingSlice.actions;
export default pageHeadingSlice.reducer;
